import React, {useEffect, useCallback, useMemo, useReducer} from "react";
import c  from "../configEAI.json";
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

export default function EAIWrapper() {

    const [stateData, setStateData] = useReducer(
        (state, newState) => ({...state, ...newState}),
        {}
    )    

    const capitalize = useCallback(s => {
        return s && s[0].toUpperCase() + s.slice(1);
    }, [])

    const getValue = useCallback(key => {
        if (stateData?.[key] === undefined) return "";
        return stateData[key];
    }, [stateData])

    const getIntValue = useCallback(k => {
        let v = getValue(k)
        if (!v) return v
        return parseInt(v)
    }, [getValue])

    const getSur = useCallback(() => {
        let count = getIntValue("tab_16") + getIntValue("tab_17") + getIntValue("tab_18") + getIntValue("tab_19_z");
        console.log(17, count);
        if (count > 25) return(10);
        if (count > 20) return(7);
        if (count > 15) return(5);
        if (count > 10) return(3);
        return(1);
    }, [getIntValue])

    const checkForKeys = useCallback((a = ["tox", "am", "con", "sur", "tab_16", "tab_17", "tab_18", "tab_19_x", "tab_19_y", "tab_19_z"]) => {
        let pattern = a.map(v => (stateData.hasOwnProperty(v) && stateData[v] !== undefined))
        return (!pattern.includes(false));
    }, [stateData])

    const tab19 = useMemo(() => {
        let x = { 
            key: "tab_19_x",
            label: c.tab_19.label_x,
            items: c.tab_19.items_x.map((v,k)=>({label:v,value:k})),
        }
        let y = { 
            key: "tab_19_y",
            label: c.tab_19.label_y,
            items: c.tab_19.items_y.map((v,k)=>({label:v,value:k})),
        }
        let result = [x].concat(y);

        if (stateData?.tab_19_x !== undefined && stateData?.tab_19_y !== undefined) {
            let n =  c.tab_19.items[stateData.tab_19_y][stateData.tab_19_x].split("-").map(v => parseInt(v))
            let zn = [n[0]];
            if (n.length === 2) {
                for (let i = n[0]+1; i <= n[1]; i++) {
                    zn.push(i);
                  }
            }    
            let z = { 
                key: "tab_19_z",
                label: c.tab_19.label_z,
                items: zn.map(v => ({ label: v + "b", value: v })).reverse(),
            }
            
            result.push(z)
        }
        return result;
    },[stateData?.tab_19_x, stateData?.tab_19_y])

    useEffect(() => {
        if (stateData.tab_19_z !== undefined ) {
            if(! tab19[2]?.items?.find(v => v.value === stateData.tab_19_z) ) {
                return handleChange({tab_19_z: undefined});
            }
        }
    }, [stateData, tab19])

    useEffect(() => {
        let checked = checkForKeys(["tab_16", "tab_17", "tab_18", "tab_19_x", "tab_19_y", "tab_19_z"])
        let sur = checked ? getSur() : undefined;
        if (stateData.sur !== sur ) {
            return handleChange({sur});
        }
    }, [stateData, checkForKeys, getSur])

    let result = useMemo(() => {
        let r = {n:"", t:""}
        if (checkForKeys() && !(stateData.sol === "a" && stateData.sol2 === undefined)){           
            let sol = getValue("sol") === "a" ? getIntValue("sol2") : getIntValue("sol");
            let sur = getSur();
            r.n = getIntValue("tox") * getIntValue("am") * (getIntValue("con") + sol + sur);
            r.t = r.n > 100 ? c.notices[0] : c.notices[1];
            return(r);
        } else {
            return(r);
        }
    }, [stateData, checkForKeys, getValue, getIntValue, getSur])
    
    const getParameter = item => {
        let p = "";
        if (!item?.key) {
            return p;
        }
        if (item.key === "sol") {
            let v = getValue("sol") === "a" ? getIntValue("sol2") : getIntValue("sol")
            p = `Parameter ${capitalize(item.key)}: ${v}`
        }
        if (["tox", "am", "con", "sur"].includes(item.key)) {
            p = `Parameter ${capitalize(item.key)}: ${getIntValue(item.key)}`
        }
        if (["tab_16", "tab_17", "tab_18", "tab_19_z"].includes(item.key)) {
            let t = item.key.split("tab_")[1]
            p = `Tab.${parseInt(t)} - body: ${getIntValue(item.key)}`
        }
        return p;
    }

    const handleChange = d => {
        setStateData({...d})
    }

    let sol2 = c.items.find(v=>v.key === "sol2")

    return (
        <Form>
            <div>
                <h2>{c.header}</h2>
                <p>{c.description}</p>
            </div>
            <Container fluid className="mb-4 border border-primary rounded">
            {/* <Container fluid className="mb-4"> */}
                <Row >
                    {c.items.slice(0, 4).map((v,k) => 
                        <BlockOne key={k} item={v} onChange={handleChange} getValue={getValue} parameter={getParameter(v)} />
                    )}
                    <BlockOne item={sol2} onChange={handleChange} getValue={getValue} parameter={getParameter(sol2)} disabled={stateData.sol !== "a"} />
                    {c.items.slice(-1).map((v,k) => 
                        <BlockOne key={k} item={v} onChange={handleChange} getValue={getValue} parameter={getParameter(v)} disabled />
                    )}
                </Row>
                <Row>
                    {c.items.slice(5,-1).map((v,k) => 
                        <BlockOne key={k} item={v} onChange={handleChange} getValue={getValue} parameter={getParameter(v)} />
                    )}
                    {tab19.map((v,k) => 
                        <BlockOne key={k} item={v} onChange={handleChange} getValue={getValue} parameter={getParameter(v)} />
                    )}
                </Row>
                <Row className={`rounded ${result.t ? "border border-danger" : ""}`} >
                    <Col sm={12} className={`pt-3`} role={"log"}>
                        <h3>
                            {"Výsledok: EAI index = Tox x Am x (Con+Sol+Sur): "} 
                            <strong>{result.n}</strong> 
                        </h3>
                        {result.t &&
                            <p>{result.t}</p>
                        }
                    </Col>
                </Row>
            </Container>
        </Form>
    );   
}

const BlockOne = props => {

    const {item, onChange:handleChangeTop, getValue, parameter, disabled } = props

    const handleChange = useCallback(({item, v}) => {
        handleChangeTop({[item.key]: v.value})
    }, [handleChangeTop])

    return (
        <Col md={"4"}>
            <Row className={"h-100 border border-primary rounded"} >
                <Col sm={12}>
                    <ItemBlock item={item} onChange={handleChange} getValue={getValue} disabled={disabled} />
                </Col>
                {parameter &&
                    <Col sm={12}>
                        {/* <h5>{`Parameter ${capitalize(item.key)}: ${getValue(item.key)}`}</h5> */}
                        <h5>{parameter}</h5>
                    </Col>
                }
            </Row>
        </Col>
    );
}


const ItemBlock = ({item, onChange, getValue, disabled}) => 
    <fieldset className="mb-2">
        <legend>{item.label}</legend>
        {item.items.map((v, k) => 
            <Form.Check  key={k}
                type={"radio"}
                id={`id_${item.key}_${k}_${v.value}`}
                name={`name_${item.key}_${k}`}
                label={v.label}
                checked={getValue(item.key) === v.value}
                onChange={() => onChange({item, v})}
                disabled={disabled}
            />
        )}
    </fieldset>